import { simbaStyled } from '@naf-simba/theme';

export const Wrapper = simbaStyled('div')(({ theme }) => ({
  width: 'fit-content',
  maxWidth: '100%',

  [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
    width: '100%',
  },
}));

export const ReadMoreWrapper = simbaStyled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing('l'),
}));
